module.exports = __webpack_public_path__ + "static/media/focusDIYLogo.9bec1716.png";